
import React from "react";
import cfpPdf from "../../../assets/bonus-history-pdf/Bonus_History_Cashflow_Protection_Plus.pdf";
import fspPdf from "../../../assets/bonus-history-pdf/Bonus_Hisotry_Flexi_Savings_Plan.pdf"
import AIpPdf from "../../../assets/bonus-history-pdf/Bonus_History_Active_Income_Plan.pdf"
import slPdf from "../../../assets/bonus-history-pdf/Bonus_History_Smart_Lifestyle.pdf"
import lgPdf from "../../../assets/bonus-history-pdf/Bonus_History_Legacy_Plus.pdf"
import ProductConstants from "constants/ProductConstants";
import "./view-bonus-history-button.css"


function ViewBonusHistoryButton(props) {
    const { productData, style } = props

    const viewPdf = (data) => {
        let productName = data.product_name;
        switch (productName) {
            case ProductConstants.FLEXI_SAVINGS_PLAN_FLEXI_INCOME:
                window.open(fspPdf);
                break;
            case ProductConstants.FLEXI_SAVINGS_PLAN_LARGE_SUM_OPTION:
                window.open(fspPdf);
                break;
            case ProductConstants.CASH_FLOW_PROTECTION_PLUS:
                window.open(cfpPdf);
                break;
            case ProductConstants.SMART_LIFESTYLE:
                window.open(slPdf);
                break;
            case ProductConstants.LEGACY_PLUS_INCOME:
                window.open(lgPdf)

            case ProductConstants.ACTIVE_INCOME_PLAN:
                window.open(AIpPdf)

            case ProductConstants.FLEXI_DREAM_PLAN:
            // window.open(lgPdf)

            case ProductConstants.FLEXI_GOAL_SECURE:
            // window.open(lgPdf)

            default:
                break;
        }
    };

    return (
        <>
            <span className={`btn p-0 LA-btn font-size-14 view-bonus-history ${style} `} onClick={() => { viewPdf(productData?.data) }}>View Bonus history</span>
        </>
    )
}
export default ViewBonusHistoryButton;